import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"

import _ from "lodash"

import { Field } from "formik"
import { MultiSelect } from "primereact/multiselect"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function ParticipantIds({ field, block, index }) {
  const [participantList, setParticipantList] = useState([])
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GET_PARTICIPANTS = gql`
    query Participants($staff_id: ID!, $organization_id: ID!) {
      participants: getAllActiveParticipants(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        participant_id
        participant_membership_status
        participant_name_first
        participant_name_last
      }
    }
  `
  const { loading } = useQuery(GET_PARTICIPANTS, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    onCompleted: ({ participants }) => {
      const newParticipantList = _.map(participants, (participant) => {
        return {
          key: participant.participant_id,
          label: `${_.unescape(
            participant.participant_name_first
          )} ${_.unescape(participant.participant_name_last)}`,
        }
      })
      return setParticipantList(newParticipantList)
    },
  })

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: "block",
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form }) => (
            <>
              <MultiSelect
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={participantList}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
